import Strings from './../common/Strings';

export function getCurrencyText(currency) {
  if (currency === Strings.CURRENCIES.dollarCode) {
    return Strings.CURRENCIES.dollar;
  } else if (currency === Strings.CURRENCIES.euroCode) {
    return Strings.CURRENCIES.euro;
  } else if (currency === Strings.CURRENCIES.yenCode) {
    return Strings.CURRENCIES.yen;
  } else if (currency === Strings.CURRENCIES.poundCode) {
    return Strings.CURRENCIES.pound;
  } else if (currency === Strings.CURRENCIES.rubleCode) {
    return Strings.CURRENCIES.ruble;
  } else if (currency === Strings.CURRENCIES.rupeeCode) {
    return Strings.CURRENCIES.rupee;
  } else if (currency === Strings.CURRENCIES.rialCode) {
    return Strings.CURRENCIES.rial;
  }

  return Strings.CURRENCIES.dollar;
}



// WEBPACK FOOTER //
// ./src/helpers/currency.js